import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Image from 'react-bootstrap/Image';
import placeholder from '../assets/images/placeholder.png';
import { StyledMember, StyledPanel, StyledItem } from '../stylesheets/styles';
import { API_URL, API_IMAGE_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

const Item = ({ activity }) => {
  const {id, subject, content, publishDate, thumbnail, isRead } = activity;
  

  const thumbnail_url = `${API_IMAGE_URL}${thumbnail}`;
  if (isEmpty(activity)) { return null; }
  

  return (
    <StyledItem className='item-wrap'>
      <Link className='item-link' to={`/activity/${id}`}>
        <div className={classNames('item', isRead ? 'read' : 'unread')}>
          <div className='item-img'>
            <Image src={thumbnail ? thumbnail_url : placeholder} alt="Activity Thumbnail" />
          </div>
          <div className='item-content'>
            <Badge className='subject' bg="primary">{subject}</Badge>
            <div className="content static-content ck-content" style={{ filter: "grayscale(1) brightness(0)" }} dangerouslySetInnerHTML={{ __html: content }} />
            <p className='item-date d-block d-md-none ps-0 text-left'>{new Date(publishDate).toLocaleDateString()}</p>
          </div>
          <p className='item-date d-none d-md-block'>{new Date(publishDate).toLocaleDateString()}</p>
        </div>
      </Link>
    </StyledItem>
  );
}

const Activity = (props) => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/activity`);
        if (response.data.isSuccess) {
          setActivities(response.data.result);
        }
      } catch (error) {
        console.error('Error fetching activities:', error);
      }
    };

    fetchActivities();
  }, []);

  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel className='content-panel'>
                <div className="hgroup">
                  <h1 className="text-center">最新活動</h1>
                </div>
                <section className='section'>
                  <StyledItem className='item-wrap item-header d-none d-md-flex'>
                    <div className='item-img'>
                      內容
                    </div>
                    <div className='item-date'>發布日期</div>
                  </StyledItem>
                  {activities.map(activity => (
                    <Item key={activity.id} activity={activity} />
                  ))}
                </section>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default Activity;